<template>
  <div class="app">
    <Header></Header>
    <div class="container">
      <div class="columns">
        <div class="column is-2">
          <Menu></Menu>
        </div>
        <div class="column is-10">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import imsr from "@/imsr-api";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    Menu,
    Header,
  },
  setup() {
    const forcePage = ref();
    const store = useStore();
    const route = useRoute();
    const notfound = ref(false);
    const projectId = ref();

    const deviceErrorCheck = async () => {
      if (route.params.projectId && store.getters.projectRole === "admin") {
        const params = {
          projectId: route.params.projectId,
          tenantId: store.getters.tenantId,
        };
        const alerts = await imsr.imsrGetApi("/devices/alerts", params);
        store.commit("setErrorCount", alerts.errorCount);
      } else {
        store.commit("setErrorCount", 0);
      }
    };

    onMounted(async () => {
      if (route.params.projectId === undefined) {
        projectId.value = store.getters.projectId;
      } else {
        projectId.value = route.params.projectId;
      }

      if (
        route.params.projectId !== undefined &&
        route.params.projectId != store.getters.projectId
      ) {
        const params = {
          projectId: route.params.projectId,
          tenantId: store.getters.tenantId,
        };
        const project = await imsr.imsrGetApi("/projects", params);
        store.commit("setProjectId", project.projectId);
        store.commit("setProjectName", project.projectName);
        store.commit("setTimezone", project.timezone);
        store.commit("setZoneinfo", project.zoneinfo);
        store.commit("setProjectRole", project.userRole);
      }
      deviceErrorCheck();
    });

    // URLが変わったら再チェックを実施する
    watch(
      () => route.path,
      () => {
        deviceErrorCheck();
      },
      { immediate: true }
    );

    return {
      forcePage,
      // authState,
      notfound,
      projectId,
      projectName: computed(() => store.getters.projectName),
      projectRole: computed(() => store.getters.projectRole),
      userRole: computed(() => store.getters.userRole),
    };
  },
};
</script>
